export const FETCH_PLAYER_GROUPS = 'playerGroups/FETCH_PLAYER_GROUPS';
export const FETCH_PLAYER_GROUPS_FAILURE = 'playerGroups/FETCH_PLAYER_GROUPS_FAILURE';
export const FETCH_PLAYER_GROUPS_SUCCESS = 'playerGroups/FETCH_PLAYER_GROUPS_SUCCESS';

export const RESET_STATE = 'playerGroups/RESET_STATE';

